import HelpIcon from '@mui/icons-material/HelpOutlineOutlined'
import { Button, IconButton } from '@mui/material'
import NextLink from 'next/link'
import { EXTERNAL_LINKS } from '~/lib/externalLinks'

export const HelpButton = () => {
  return (
    <>
      {/* デスクトップ用 */}
      <Button
        aria-label="よくある質問ページを開く"
        variant="outlined"
        startIcon={<HelpIcon />}
        sx={{
          bgcolor: (theme) => theme.palette.white,
          display: {
            xs: 'none',
            sm: 'flex',
          },
        }}
        href={EXTERNAL_LINKS.FAQ}
        target="_blank"
        rel="noopener noreferrer"
        LinkComponent={NextLink}
      >
        よくある質問
      </Button>

      {/* モバイル用 */}
      <IconButton
        aria-label="よくある質問ページを開く"
        sx={{
          display: { xs: 'flex', sm: 'none' },
        }}
        href={EXTERNAL_LINKS.FAQ}
        target="_blank"
        rel="noopener noreferrer"
        LinkComponent={NextLink}
      >
        <HelpIcon sx={{ color: (theme) => theme.palette.primary.main }} />
      </IconButton>
    </>
  )
}
